import React from 'react';
import './Dock.css';

function DockIcon({ id, title, icon, href, ariaLabel, onOpen }) {
  const inner = (
    <>
      <div className="icon">
        {icon}
      </div>
      <span className="dock-icon-label">{title}</span>
    </>
  );

  // External-link entries (e.g. Shop → ticket page) render as a real anchor:
  // keyboard/middle-click friendly, opens in a new tab, and noopener/noreferrer
  // keeps the external page from getting a handle on this window.
  if (href) {
    return (
      <a
        className="dock-icon-wrapper dock-icon-link"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={ariaLabel || `${title} (opens in a new tab)`}
      >
        {inner}
      </a>
    );
  }

  return (
    <div
      className="dock-icon-wrapper"
      onClick={() => onOpen(id)}
    >
      {inner}
    </div>
  );
}

export default function Dock({ apps, onOpenApp }) {
  return (
    <div className="dock">
      {apps.map(app => (
        <DockIcon
          key={app.id}
          id={app.id}
          title={app.title}
          icon={app.icon}
          href={app.href}
          ariaLabel={app.ariaLabel}
          onOpen={onOpenApp}
        />
      ))}
    </div>
  );
}
